import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Logo } from '../../../shared/assets/svg'
import NavButton from './NavButton'
import { cn } from '../../../shared/lib/utils'
import FooterAvatar from './FooterAvatar'
import { NAV_LINKS } from '../constants/navLinks'
import { SidebarTrigger, useSidebar } from '../../../shared/ui/sidebar'
import SmallLogo from '../../../shared/assets/svg/SmallLogo'

const SideNav = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const {
    state,
    open,
  } = useSidebar()

  return (
    <div className={cn("bg-primary-60 md:w-[96px] flex flex-col justify-between h-full pt-3 lg:pl-0",
      open ? "lg:w-[248px]" : "lg:w-[96px] md:pl-0"
    )}>
      <div className={cn('flex items-center justify-center w-full',
        state === 'collapsed' ? "lg:justify-center md:justify-end px-1" : "lg:justify-between")}>
        <Link to="/dashboard" className=''>
          {state !== 'collapsed' ? <Logo className='block pl-2 md:hidden lg:block' />
            :
            <SmallLogo className='hidden md:block pr-2' />}
        </Link>

        <SidebarTrigger className='hidden fit -ml-7 lg:grid items-center justify-center' />
      </div>

      <nav className={cn("h-[80vh] w-full px-0 flex flex-col space-y-7 scrollbar-hide overflow-y-auto",
        state === 'collapsed' ? "md:mx-auto justify-start items-center" : "justify-start items-start"
      )}>
        {Object.entries(NAV_LINKS).map(([title, navs], index) => {
          const isFirst = title === "FIRST";
          return (
            <div key={index} className={cn(
              !isFirst ? "mt-5" : "",
              "flex flex-col items-center space-y-1 w-11/12"
            )}>
              {!isFirst && (
                <h3
                  className={cn(
                    "inline-flex pl-3 md:pl-0 gap-3 mb-1 uppercase text-xs w-full items-center font-normal text-gray-20 md:text-[10px] lg:justify-start md:justify-center md:text-center text-left lg:text-left xl:flex",
                    state === 'collapsed' ? "lg:justify-center md:justify-center md:w-full" : "md:w-full"
                  )}
                >
                  <span>{title}</span>{" "}
                </h3>
              )}
              {navs.map((nav, itemkey) => {
                const isActive = nav.link.includes('?') ? search.slice(1) === nav.link?.split('?')[1] : pathname === nav.link
                const isDisabled = nav.link === "" || nav.link === "#"
                return (
                  <NavButton isCollapsed={state === 'collapsed'} isDisabled={isDisabled} isActive={isActive} key={nav.link + itemkey} {...nav} onNavigate={() => nav.link.includes('?') ? window.location.replace(nav.link) : navigate(nav.link)} />
                )
              })}
            </div>
          )
        })}
      </nav>

      <FooterAvatar isCollapsed={state === 'collapsed'} />
    </div>
  )
}

export default SideNav